import React from 'react';

function Testimonials() {
  return (
    <section id="testimonials" className="testimonials">
      <div className="section-inner">
        <h2 className="section-title">
          <span className="title-emerald">Customer</span> <span className="title-gold">testimonials</span>
        </h2>
        <div className="testimonials-coming-soon">
          <span className="testimonials-coming-soon-text">Coming soon</span>
          <p className="testimonials-coming-soon-sub">Hear what our clients say about their experience.</p>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
